<!--定位当前地址-->
<template>
	<div class="positioningBody">
		<div id="addressMap"></div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {}
		},
		created() {},
		mounted() {
			let _this = this
			var map = new BMap.Map("addressMap");
			var point = new BMap.Point(116.331398, 39.897445);
			map.centerAndZoom(point, 12);
			var geolocation = new BMap.Geolocation();
			geolocation.getCurrentPosition(function(r) {
				if(this.getStatus() == BMAP_STATUS_SUCCESS) {
					var mk = new BMap.Marker(r.point);
					map.addOverlay(mk);
					map.panTo(r.point);
					let cityCode = cityCodeList[r.address.city.split('市')[0]]
					if(!isempty(cityCode)) {
						//获取天气信息
						/*_this.$api.weatherApi.getWeatherData(cityCode,respon=>{
							_this.$store.cacheStore.state.weather=JSON.parse(respon)
						})*/
						$.ajax({
							type: "GET",
							url: "http://wthrcdn.etouch.cn/weather_mini?citykey="+cityCode,
							success: function(res) {
								_this.$store.cacheStore.state.weather=JSON.parse(res)
							},
							error: function(error) {

							}
						});
					}
				} else {
					alert('failed' + this.getStatus());
				}
			}, {
				enableHighAccuracy: true
			})
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.positioningBody {
		display: none;
		width: 10px;
		height: 10px;
	}
	
	#addressMap {
		width: 100%;
		height: 100%;
	}
</style>